import { useNavigate } from 'react-router'
import { getDocumentsUrlWithCurrentParams } from '~/entities/document'
import { Button, Dialog, OptiWalking, Text } from '~/shared/ui'

export function ValidateAndFinishDialog({
  username,
  onClose,
}: {
  username: string | undefined
  onClose: () => void
}) {
  const navigate = useNavigate()

  const close = () => {
    onClose()
    navigate(getDocumentsUrlWithCurrentParams())
  }

  return (
    <Dialog
      size="sm"
      onClose={close}
      actions={
        <>
          <Button
            raised
            onClick={close}
          >
            Head to queue
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-4">
        <OptiWalking />
        <div className="flex flex-col gap-2">
          <Text
            className="text-text-primary"
            appearance="SUBTITLE2"
          >
            Great catch{username ? `, ${username}` : ''}!
          </Text>
          <Text
            className="text-text-secondary"
            appearance="CAPTION"
          >
            I’ll keep an eye out for this type of document in the future.
            <br />
            Thanks for helping me improve 😊
          </Text>
        </div>
      </div>
    </Dialog>
  )
}
